var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-message"},[_c('div',[(_vm.error)?[_c('c-icon',{attrs:{"icon":"exclamation-triangle"}})]:[_c('c-spinner',{attrs:{"size":"lg"}})],_vm._v(" "),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }